import Vue from 'vue';
import { sync } from 'vuex-router-sync';
import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';
import vuetify from './plugins/vuetify';
import './plugins/vue-toasted';
import './plugins/vue-the-mask';
import './plugins/vue-carousel';
import './plugins/vue-infinite-loading';
import './plugins/vue-json-csv';
import './plugins/vue-excel';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import '@fortawesome/fontawesome-free/css/all.css';
import '@/sass/main.scss';


Vue.config.productionTip = false;

// Add router state to store
sync(store, router);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app');
